export const handleClientError = (error) => {
  return error instanceof Error ? { message: error.toString(), ignore: error.ignore } : error
}